import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useCompactTableContext } from '../../../context/compact-table-context';

export const CompactTableExpandAllButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { toggleAllRowsExpanded, allExpandedByDefault, data } = useCompactTableContext();

  return (
    <Button
      iconName={allExpandedByDefault ? 'minus' : 'plus'}
      onClick={toggleAllRowsExpanded}
      variant='tertiary'
      disabled={data.length === 0}
      className={className}
    >
      {allExpandedByDefault ? t('Collapse All') : t('Expand All')}
    </Button>
  );
};
